<template>
    <article
        :data-el-item="question.id"
        class="c-w-screen-16 relative text-gray-100 overflow-hidden bg-white border border-gray-200 rounded"
        :class="{ 'border-0': faq.id && !faq.border }"
        style="grid-row-end: span 6"
        :style="{
            'background-color': faq.backColor,
            'border-color': faq.borderColor,
            'border-radius': faq.borderRadius + 'px',
        }"
    >
        <div
            data-el-content
            class="flex flex-col p-6"
            :class="[
                faq.textAlign === 'right'
                    ? 'items-end'
                    : faq.textAlign === 'center'
                      ? 'items-center'
                      : 'items-start',
            ]"
        >
            <div class="mb-4">
                <cUtilsEdit @edit="goToQuestionField(question.id, 'questionQuestion')">
                    <h3
                        :style="{
                            color: faq.questionColor,
                            'font-size': faq.questionSize + 'px',
                        }"
                        class="font-bold text-gray-700"
                        :class="[
                            faq.textAlign === 'right'
                                ? 'text-right'
                                : faq.textAlign === 'center'
                                  ? 'text-center'
                                  : 'text-left',
                        ]"
                        v-html="questionQuestion"
                    ></h3>
                </cUtilsEdit>
            </div>

            <div
                :style="{
                    color: faq.questionColor,
                    'font-size': faq.questionSize + 'px',
                }"
                class="text-gray-700 w-full oapcity-80"
                :class="[
                    faq.textAlign === 'right'
                        ? 'text-right'
                        : faq.textAlign === 'center'
                          ? 'text-center'
                          : 'text-left',
                ]"
            >
                <cUtilsEdit @edit="goToQuestionField(question.id, 'questionAnswer')">
                    <p class="whitespace-pre-line leading-normal" v-html="questionAnswer"></p>
                </cUtilsEdit>
            </div>
        </div>
    </article>
</template>

<script>
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";
import { useFaqGoTo } from "@/views/tools/faq/utils/useFaqGoTo";

export default {
    name: "QuestionCard",
    props: {
        question: Object,
        faq: Object,
        query: String,
    },
    setup() {
        const { goToQuestionField } = useFaqGoTo();
        return { goToQuestionField };
    },
    components: { cUtilsEdit },
    computed: {
        questionQuestion() {
            return this.query
                ? this.highlightText(this.query, this.question.question)
                : this.question.question;
        },
        questionAnswer() {
            return this.query
                ? this.highlightText(this.query, this.question.answer)
                : this.question.answer;
        },
    },
    methods: {
        highlightText(query, text) {
            const myReg = new RegExp("(" + query + ")", "gi");
            return text.replace(myReg, "<span style='background: yellow'>$1</span>");
        },
    },
};
</script>
